<template>
  <div class="menu-box w-full">
    <div class="auto-container w-full">
      <Menubar :model="items" class="menuPrincipal">
        <template #start>
          <div @click="fc_goRoute('home')" class="logo flex cursor-pointer">
            <img class="imagemLogo" />
          </div>
        </template>
        <template #item="{item, props, root, hasSubmenu}">
          <a v-bind="props.action">
            <span v-bind="props.label" v-html="item.label"></span>
            <span :class="[hasSubmenu && (root ? 'pi pi-fw pi-angle-down' : 'pi pi-fw pi-angle-right')]" v-bind="props.submenuicon" />
          </a>
        </template>
        <template #end>
          <div class="flex align-items-center">
            <div class="hidden sm:block separadorIdioma" style="font-size:16px;">|</div>
            <MenuIdioma />
          </div>
        </template>
      </Menubar>
    </div>

  </div>
</template>

<script>
import Menubar from 'primevue/menubar';
import MenuIdioma from '@/components/MenuIdioma.vue';
export default {
  components: {
    Menubar,
    MenuIdioma,
  },
  data() {
    return {
      items: [
        {
          code: 'home',
          label: this.fc_getText(null, 'home', { upper: false }),
          command: () => { this.fc_goRoute('home'); },
          disabled: () => {},
        },
        {
          code: 'solucoes',
          label: this.fc_getText(null, 'solucoes', { upper: false }),
          command: () => { this.fc_goRoute('solucoes'); },
          disabled: () => {},
        },
        {
          code: 'servicos',
          label: this.fc_getText(null, 'servicos', { upper: false }),
          command: () => { this.fc_goRoute('servicos'); },
          disabled: () => {},
        },
        {
          code: 'clientes',
          label: this.fc_getText(null, 'clientes', { upper: false }),
          command: () => { this.fc_goRoute('clientes'); },
          disabled: () => {},
        },
        {
          code: 'sobreNos',
          label: this.fc_getText(null, 'sobreNos', { upper: false }),
          command: () => { this.fc_goRoute('sobreNos'); },
          disabled: () => {},
        },
        {
          code: 'contactos',
          label: this.fc_getText(null, 'contactos', { upper: false }),
          command: () => { this.fc_goRoute('contactos'); },
          disabled: () => {},
        },
      ]
    };
  },
  props: {},
  computed: {},
  watch: {},
  methods: {},
  created() {},
  mounted() {
    (function () {
      var menu = document.getElementById('menu');
      window.addEventListener('scroll', function () {
        if (window.scrollY > 0) menu.classList.add('menuFixo');
        else menu.classList.remove('menuFixo');
      });
    })();
  },
  unmounted() {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
.auto-container {
  position: relative;
}
.logo {
  padding: 10px 0px;
}

@media screen and (min-width: 1040px) {
  .logo {
    width: 350px;
  }
}

.imagemLogo {
  content:url("@/assets/logo_black.png");
}
.menuFixo .imagemLogo {
  content:url("@/assets/logo.png");
}
.imagemLogo {
  max-width: 248px;
  height: 60px;
}
@media screen and (max-height: 600px) and (max-width: 992px) {
  .imagemLogo {
    width: 155px;
    height: 70px;
  }
}
.menuPrincipal.p-menubar {
  position: relative;
  left: 0px;
  top: 0px;
  z-index: 999;
  width: 100%;
  padding: 0px 15px 0px 15px;
  margin: 0 auto;
}
.menuFixo .menuPrincipal.p-menubar .p-menubar-item > .p-menubar-item-content .p-menubar-item-link {
  color: #fff;
}
.menuPrincipal.p-menubar:deep(.p-menubar-item > .p-menubar-item-content .p-menubar-item-link) {
  font-size: .75rem;
  font-weight: 500;
  position: relative;
  display: block;
  padding: 40px 20px;
  color: black;
  line-height: 1em;
  text-align: center;
  text-transform: capitalize;
  letter-spacing: 0px;
  opacity: 1;
}
.menuPrincipal.p-menubar.p-menubar-mobile:deep(.p-menubar-item > .p-menubar-item-content) {
  border-top: 1px solid rgba(255, 255, 255, 1) !important;
  border-bottom: none;
  opacity: 1 !important;
  top: 0px !important;
  left: 0px !important;
  visibility: visible !important;
}
.menuPrincipal.p-menubar.p-menubar-mobile:deep(.p-menubar-item > .p-menubar-item-content .p-menubar-item-link) {
  border: none !important;
  font-size: 15px !important;
  padding: 10px 10px;
  color: white;
  background-color:black;
  line-height: 22px;
  color: #ffffff;
  text-align: left;
}

@media screen and (min-width: 768px) {
  .menuPrincipal.p-menubar:deep(.p-menubar-item > .p-menubar-item-content .p-menubar-item-link) {
    font-size: .75rem;
  }
}
@media screen and (min-width: 992px) {
  .menuPrincipal.p-menubar:deep(.p-menubar-item > .p-menubar-item-content .p-menubar-item-link) {
    font-size: .875rem;
  }
}
@media screen and (min-width: 1200px) {
  .menuPrincipal.p-menubar:deep(.p-menubar-item > .p-menubar-item-content .p-menubar-item-link) {
    font-size: 1rem;
  }
}
.menuPrincipal.p-menubar:deep(.p-menubar-item .p-menubar-item-text),
.menuPrincipal.p-menubar:deep(.p-menubar-item .p-menubar-item-icon) {
  color: #fff;
}
@media screen and (max-width:768px) {
  .menuPrincipal.p-menubar.p-menubar-mobile-active:deep(.p-menubar-root-list) {
    max-height: 45vh;
    overflow-y: auto;
    flex-direction: row;
  }
}
.menuPrincipal.p-menubar:deep(.p-menubar-button) {
  background: #000;
  color: #fff;
  padding:10px 10px;
  margin-right: 10px;
}
@media screen and (max-width: 575px) {
  .menuPrincipal.p-menubar:deep(.p-menubar-button) {
    margin-right: -30px;
  }
}
.menuPrincipal.p-menubar.p-menubar-mobile-active:deep(.p-menubar-root-list) {
  background-color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.15);
  display: flex;
  align-items: center;
  justify-content: center;
}

.menuPrincipal.p-menubar.p-menubar-mobile-active:deep(.p-menubar-root-list .p-menubar-item:hover > .p-menubar-item-content .p-menubar-item-link)  {
   background-color: var(--ibase-color) !important;
   transition: all 300ms ease;
}

</style>
